module.exports = __webpack_public_path__ + "img/fyy-play.b19c6414.png";